import { render, staticRenderFns } from "./bestseller.vue?vue&type=template&id=3fef39c7"
import script from "./bestseller.vue?vue&type=script&lang=js"
export * from "./bestseller.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports